module.exports = __webpack_public_path__ + "img/user.8374c455.jpg";